import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { retry } from 'rxjs/operators';
import { interval, Observable, Subject } from 'rxjs';
import { filter, switchMap, take, timeout } from 'rxjs/operators';
import PouchDB from 'pouchdb-browser';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';

@Injectable({
  providedIn: 'root'
})
export class BoletoService {

  private ENDPOINT = environment.ENDPOINTS.BOLETO;
  // private db: any;
  public base = {}
  actualUser: any;

  constructor(
    private store: Store<AppState>,
    private http: HttpClient
  ) {
    this.store.select(selectUser).subscribe(user => {
      this.actualUser = user;
      console.log(this.actualUser);

    })
    this.polling()
  }

  saveBoleto(data: any) {
    return this.http.post(`${this.ENDPOINT}`, data,{ responseType: 'blob' }).toPromise();
  }


  getBoletos() {
    return this.http.get<any[]>(`${this.ENDPOINT}`);
  }
  getTarifas() {
    return this.http.get<any[]>(`${this.ENDPOINT}/get/tarifas/`);
  }

  getBoletosActivos() {
    return this.http.get<any[]>(`${environment.ENDPOINTS.BOLETO}/get/boletos-activos/`)
      .pipe(
        retry(3)
      );
  }

  polling() {
    if (this.actualUser.tipo == 22) {

    }
    interval(3000).pipe(
      switchMap(() => this.getBoletosActivos()),
      filter((data: any) => {
        this.base = data;
        //console.log(this.base);

        return data;
      }),
      take(1),
      timeout(10000)
    ).subscribe(result => {
      this.polling();
      //console.log(result);
    }, error => {

      this.polling();

    });
  }
  downloadPDF(file:Blob, nameFile){
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = nameFile;
    link.click();
    return url;
  }
}
